// @flow

import React, { Component } from 'react';
import StyleSheet from 'stilr';

const common = {
  padding: 15,
  border: '1px solid transparant',
  borderRadius: 4,
  margin: '15px 0'
};

const styles = StyleSheet.create({
  alert: {
    ...common,
    color: '#3c763d',
    background: '#dff0d8',
    bordercolor: '#d6e9c6'
  }
});

class AlertWithLink extends Component {
  render() {
    return (
      <div className={`${styles.alert}`}>
        {this.props.text}{' '}
        <a href={this.props.path} download>
          {this.props.linkText}
        </a>
      </div>
    );
  }
}

export default AlertWithLink;
